import { Component } from '@angular/core';

@Component({
  selector: 'app-billing-job-posting-details',
  templateUrl: './billing-job-posting-details.component.html',
  styleUrls: ['./billing-job-posting-details.component.css']
})
export class BillingJobPostingDetailsComponent {

}
